import PropTypes from 'prop-types'
import React from 'react'
import STSComponent from '../../STSComponent/STSComponent'

class SummaryTracking extends STSComponent {
  returnTableRows = () => {
    const randomValues = [11778, 6, 3] // TODO: remove when API returns data
    return this.props.tableSigns.map((item, i) => {
      return <div className="summary-tracking-row" key={i}>
        <div>{item}</div>
        <div>{randomValues[i]}</div>
      </div>
    })
  }

  render () {
    const { title } = this.props
    return <div className="summary-tracking-wrapper">
      <div className="summary-tracking-title">{title}</div>
      <div>{this.returnTableRows()}</div>
    </div>
  }

  static propTypes = {
    title: PropTypes.string,
    tableSigns: PropTypes.array
  }
}

export default SummaryTracking



// WEBPACK FOOTER //
// ./src/components/ManagementTrackingStats/components/SummaryTracking.js